import React, { Fragment } from "react";
import { styled, Heading } from "@sourceful/shared-components";
import { SanityTechnicalContentItem } from "@sourceful/shared-types";
import TechnicalContentSpecItem from "./technicalContentSpecItem/TechnicalContentSpecItem";
import TechnicalContentSpecItemHeader from "./technicalContentSpecItem/TechnicalContentSpecItemHeader";
import { accordionStyles } from "./accordionStyles";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

const TechnicalContentSpecContainer = styled("div", {});

interface TechnicalContentSpecProps {
  item: SanityTechnicalContentItem;
}

const TechnicalContentSpec = ({ item }: TechnicalContentSpecProps) => {
  const { title, isTitleHidden, technicalContentSpecItems } = item;

  return (
    <>
      {!isTitleHidden && (
        <Heading fontSize={4} level={3} css={{ textAlign: "center", marginBottom: "20px" }}>
          {title}
        </Heading>
      )}
      <TechnicalContentSpecContainer>
        <Accordion
          preExpanded={[0]}
          allowZeroExpanded
          allowMultipleExpanded
          className={accordionStyles()}
        >
          {technicalContentSpecItems.map((technicalContentSpecItem, key) => (
            <Fragment key={`${technicalContentSpecItem.title}-${key}`}>
              <AccordionItem uuid={key}>
                <AccordionItemHeading>
                  <AccordionItemButton
                    style={{
                      userSelect: "none",
                    }}
                  >
                    <TechnicalContentSpecItemHeader item={technicalContentSpecItem} />
                  </AccordionItemButton>
                </AccordionItemHeading>

                <AccordionItemPanel>
                  <TechnicalContentSpecItem item={technicalContentSpecItem} />
                </AccordionItemPanel>
              </AccordionItem>
            </Fragment>
          ))}
        </Accordion>
      </TechnicalContentSpecContainer>
    </>
  );
};

export default TechnicalContentSpec;
